import {
  createFaasProcedureConfig,
} from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';
import withAdsIdPrefix from '@americanexpress/iguazu-procedures/utils/withAdsIdPrefix';
import withStatusResponse from '@americanexpress/iguazu-procedures/utils/withStatusResponse';
import { readCustomerProductDetailsV1, readCustomerProductsV2 } from '@americanexpress/product-ducks';
import {
  clearProcedureResult,
  configureIguazuRPC,
  queryProcedureResult,
  setProcedures,
} from 'iguazu-rpc';
import { compose } from 'redux';
import { getModuleState, getOneIdentityCorrelationId } from './selectors';
import withCorrelationId from './withCorrelationId';

const READ_USER_SESSION_HASH = 'ReadUserSession28c5073d9b07';
const DELETE_USER_SESSION_HASH = 'DeleteUserSession8e67e5b5fe03';

const configure = compose(
  withCorrelationId(
    ({ getState }) => getOneIdentityCorrelationId(getState())
  ),
  withStatusResponse,
  withAdsIdPrefix
);

const clearCacheModifier = ({ cache }) => ({ action }) => (
  action === 'clear' ? cache.clear() : cache
);

const clearCacheOnSuccess = (procedureName) => ({ result: { status } }) => (
  status === 200
    ? { [procedureName]: (modifyCache) => modifyCache({ action: 'clear' }) }
    : {}
);

const getFetchArgs = () => ({
  method: 'GET',
  cache: 'no-store',
});

export const configureIguazuProcedures = () => {
  configureIguazuRPC({
    getToState: (state) => getModuleState(state).get('procedures'),
  });

  setProcedures({
    readUserSession: configure({
      ...createFaasProcedureConfig(
        'ReadUserSession.v1',
        getFetchArgs,
        () => READ_USER_SESSION_HASH
      ),
      cacheModifier: clearCacheModifier,
      modifyOtherCaches: clearCacheOnSuccess('deleteUserSession'),
    }),
    deleteUserSession: configure({
      ...createFaasProcedureConfig(
        'DeleteUserSession.v1',
        getFetchArgs,
        () => DELETE_USER_SESSION_HASH
      ),
      cacheModifier: clearCacheModifier,
      modifyOtherCaches: clearCacheOnSuccess('readUserSession'),
    }),
    readCustomerProductsV2,
    readCustomerProductDetailsV1,
  });
};

export const queryUserSession = (args = {}) => (dispatch) => dispatch(queryProcedureResult({
  procedureName: 'readUserSession',
  args,
}));

export const clearUserSessionResult = (dispatch) => dispatch(
  clearProcedureResult({ procedureName: 'readUserSession' })
);

export const deleteUserSession = (args = {}) => (dispatch) => dispatch(queryProcedureResult({
  procedureName: 'deleteUserSession',
  args,
})).promise;
